<template>
  <div class="TheSidebar" v-if="meta.header !== false">
    <el-row>
      <el-col :span="24">
        <el-menu
          :default-active="activeLink"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-menu-item id="daskboard-menu" index="1" @click="gotoDashboard">
            <font-awesome-icon class="icon" :icon="['fal', 'home']" />
            <span>ダッシュボード</span>
          </el-menu-item>

          <el-menu-item id="home-menu" index="2" @click="gotoHome">
            <font-awesome-icon class="icon" :icon="['fal', 'clipboard-list']" />
            <span>注文管理</span>
          </el-menu-item>

          <el-menu-item index="3" @click="gotoCustomer">
            <font-awesome-icon class="icon" :icon="['fal', 'store-alt']" />
            <span>得意先管理</span>
          </el-menu-item>

          <el-menu-item index="4" @click="gotoNotification">
            <font-awesome-icon class="icon" :icon="['fal', 'bells']" />
            <span>お知らせ管理</span>
          </el-menu-item>

          <el-menu-item index="5" @click="gotoVariantCharacterGroup">
            <font-awesome-icon class="icon" :icon="['fal', 'books']" />
            <span>異体字管理</span>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  components: {},
  mounted () {},
  data () {
    return {
      handleOpen: () => {},
      handleClose: () => {},
      activeLink: "1",
    };
  },
  watch: {
    $route (to) {
      const route = to.path;
      if (route === "/admin/dashboard") {
        this.activeLink = "1";
      } else if (route === "/admin/home") {
        this.activeLink = "2";
      } else if (route.includes("/admin/orders")) {
        this.activeLink = "2";
      } else if (route === "/admin/clients") {
        this.activeLink = "3";
      } else if (route === "/admin/notifications") {
        this.activeLink = "4";
      } else if (route === "/admin/variantCharacterGroups") {
        this.activeLink = "5";
      }
    },
  },
  computed: {
    currentUser () {
      return this.$store.state.user;
    },

    title () {
      return this.$route.meta.title;
    },

    meta () {
      return this.$route.meta;
    },
  },
  methods: {
    gotoHome () {
      this.removeClass();
      const { $router } = this;
      $router.push("/admin/home");
    },
    gotoCustomer () {
      this.removeClass();
      const { $router } = this;
      $router.push("/admin/clients");
    },
    onClickBell () {
      this.$notify({
        title: "休業日のお知らせ",
        message:
          "年末年始のお休みは〇〇〜〇〇になります。よろしくお願いします。",
      });
    },
    onClickCancelOrder () {
      const { $router } = this;
      $router.push("/home");
    },
    gotoDashboard () {
      this.removeClass();
      const { $router } = this;
      $router.push("/admin/dashboard");
    },
    gotoNotification () {
      this.removeClass();
      const { $router } = this;
      $router.push("/admin/notifications");
    },
    gotoVariantCharacterGroup () {
      this.removeClass();
      const { $router } = this;
      $router.push("/admin/variantCharacterGroups");
    },
    removeClass () {
      var isWhiteClass = document.getElementsByClassName("white-color-change");
      var isOrangeClass = document.getElementsByClassName(
        "orange-color-change"
      );
      if (isWhiteClass.length > 0) {
        document
          .getElementById("daskboard-menu")
          .classList.remove("white-color-change");
      }
      if (isOrangeClass.length > 0) {
        document
          .getElementById("home-menu")
          .classList.remove("orange-color-change");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.TheSidebar {
  height: 100%;
  background: $background-sidebar;
}
.icon {
  margin-right: 10px;
  min-width: 17px;
}
.TheSidebar .el-menu {
  border-right: none !important;
}
</style>
